import { render, staticRenderFns } from "./ZskModal.vue?vue&type=template&id=f5cb4f90&scoped=true&"
import script from "./ZskModal.vue?vue&type=script&lang=js&"
export * from "./ZskModal.vue?vue&type=script&lang=js&"
import style0 from "./ZskModal.vue?vue&type=style&index=0&id=f5cb4f90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb4f90",
  null
  
)

export default component.exports